import { notFound } from "@tanstack/react-router";

export default function numericId(param: string): number {
  if (!/^[1-9]\d*$/.test(param)) throw notFound();

  const id = Number(param);
  if (!Number.isSafeInteger(id)) throw notFound();
  return id;
}
